import { render, staticRenderFns } from "./TipDistributionDetail.vue?vue&type=template&id=56a8378a&scoped=true"
import script from "./TipDistributionDetail.vue?vue&type=script&lang=js"
export * from "./TipDistributionDetail.vue?vue&type=script&lang=js"
import style0 from "./TipDistributionDetail.vue?vue&type=style&index=0&id=56a8378a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a8378a",
  null
  
)

export default component.exports